import reducer from './reducers';

import * as productOperations from './operations';

export {
  productOperations,
};

export default reducer;
